import React from 'react';

import Emojicon from 'components/generic/Emojicon.component';
import Space from 'components/generic/Space.component';
import { BackToLoginButton } from 'components/menu/SidebarFooter.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './NoAccessPanel.module.scss';

const TemporaryUnavailablePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <Emojicon description="warning" value={S.waitTriangle} />
      </p>
      <p>
        <Space>{t('composite.noAccessPanel.description1.part1')}</Space>
      </p>
      <p>
        <Space>{t('composite.noAccessPanel.description1.part2')}</Space>
      </p>
      <p>
        <Emojicon description="raised hands" value={S.recycle} />
      </p>
    </>
  );
};

const NoAccountsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        <Space>{t('composite.noAccessPanel.description2.part1')}</Space>
        <Emojicon description="thinking face" value={S.thinking} />
      </p>
      <p>
        <Space>{t('composite.noAccessPanel.description2.part2')}</Space>
        <Emojicon description="raised hands" value={S.raisedHands} />
      </p>
    </>
  );
};

const NoAccessPanel = ({ children, tag: tagFromProps }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  return (
    <div data-bem="NoAccessPanel" data-tag={tag} className={CN.container}>
      <div data-bem="NoAccessPanel__background" data-tag={tag} className={CN.bgr}>
        <div data-bem="NoAccessPanel__inner" data-tag={tag} className={CN.inner}>
          {children}
          <BackToLoginButton />
        </div>
      </div>
    </div>
  );
};

export const NoAccessDueToErrorPanel = () => (
  <NoAccessPanel tag="NoAccessDueToErrorPanel">
    <TemporaryUnavailablePage />
  </NoAccessPanel>
);

export const NoAccessDueToListPanel = () => (
  <NoAccessPanel tag="NoAccessDueToListPanel">
    <NoAccountsPage />
  </NoAccessPanel>
);

export const NoAccessLandingPanel = () => (
  <NoAccessPanel tag="NoAccessLandingPanel">
    <NoAccountsPage />
  </NoAccessPanel>
);
